import {
  Card, CardBody, Box, FormControl, FormLabel, Input, Button, useToast, Heading, Text,
} from '@chakra-ui/react'
import {useEffect, useState} from "react";
import {useFormik} from "formik";
import {useAppDataStore} from "../mobx/appDataStore";

const MailConfig = () => {
  const appDataStore = useAppDataStore()
  const {socket} = appDataStore
  const toast = useToast()
  const [clientSecretSet, setClientSecretSet] = useState(false)

  const formik = useFormik({
    initialValues: {clientId: '', clientSecret: '', tenant: 'common', redirectUri: '', frontendUrl: ''},
    onSubmit: (values) => {
      socket.emit('mail/config/set', values, (res) => {
        if (res.result === 'error') {
          return toast({title: res.error, status: 'error', duration: 9000, isClosable: true})
        }
        formik.setFieldValue('clientSecret', '')
        setClientSecretSet(res.config.clientSecretSet)
        return toast({title: 'Guardado', description: 'La configuración se guardó con éxito', status: 'success', duration: 9000, isClosable: true})
      })
    },
  })

  useEffect(() => {
    document.title = 'Tienda Digital - Configuración de correos'
    socket.emit('mail/config/get', {}, (res) => {
      if (res.result === 'error') return
      formik.setValues({clientId: res.config.clientId, clientSecret: '', tenant: res.config.tenant, redirectUri: res.config.redirectUri, frontendUrl: res.config.frontendUrl})
      setClientSecretSet(res.config.clientSecretSet)
    })
  }, []);

  return (
    <Card marginTop={5} marginLeft={5} maxWidth={'600px'}>
      <CardBody>
        <Heading size={'md'} mb={4}>Configuración Microsoft OAuth (Hotmail)</Heading>
        <Text fontSize={'sm'} mb={4} color={'gray.500'}>
          Credenciales de la app registrada en Azure AD. Se guardan cifradas en la base de datos, nunca en
          archivos ni variables de entorno.
        </Text>

        <FormControl>
          <FormLabel>Client ID</FormLabel>
          <Input name={'clientId'} onChange={formik.handleChange} value={formik.values.clientId}/>
        </FormControl>

        <FormControl mt={4}>
          <FormLabel>Client Secret {clientSecretSet && <Text as={'span'} color={'green.500'}>(ya configurado)</Text>}</FormLabel>
          <Input
            name={'clientSecret'}
            type={'password'}
            placeholder={clientSecretSet ? 'Dejar en blanco para no cambiarlo' : ''}
            onChange={formik.handleChange}
            value={formik.values.clientSecret}
          />
        </FormControl>

        <FormControl mt={4}>
          <FormLabel>Tenant</FormLabel>
          <Input name={'tenant'} onChange={formik.handleChange} value={formik.values.tenant}/>
        </FormControl>

        <FormControl mt={4}>
          <FormLabel>Redirect URI</FormLabel>
          <Input name={'redirectUri'} onChange={formik.handleChange} value={formik.values.redirectUri}
                 placeholder={`${window.location.origin}/api/v1/mail-links/microsoft/callback`}/>
          <Text fontSize={'xs'} color={'gray.500'} mt={1}>
            Debe apuntar directo al backend (ej. http://localhost:7890/api/v1/mail-links/microsoft/callback en
            desarrollo local), no al puerto del frontend — y coincidir exacto con lo registrado en Azure.
          </Text>
        </FormControl>

        <FormControl mt={4}>
          <FormLabel>Frontend URL (opcional)</FormLabel>
          <Input name={'frontendUrl'} onChange={formik.handleChange} value={formik.values.frontendUrl}
                 placeholder={'Vacío si front y backend viven en el mismo dominio (producción)'}/>
          <Text fontSize={'xs'} color={'gray.500'} mt={1}>
            Solo necesario si el frontend corre en un puerto/dominio distinto al backend (ej. desarrollo local:
            http://localhost:3001). Es a dónde te devuelve el navegador después de vincular Hotmail.
          </Text>
        </FormControl>

        <Box mt={6}>
          <Button colorScheme='blue' onClick={formik.submitForm}>Guardar</Button>
        </Box>
      </CardBody>
    </Card>
  )
}

export default MailConfig
